import Loadable from 'react-loadable';

const ProjectsDirectoryEmbed = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "ProjectsDirectoryEmbed" */ './ProjectsDirectoryEmbed'),
  loading: () => null,
});

export default ProjectsDirectoryEmbed;
